import React from 'react'
import PropTypes from 'prop-types'
import Container from '@hixme-ui/container'
import Text from '@hixme-ui/text'

const GridNoResultsOverlay = ({ style, label }) => (
  <Container
    style={{
      padding: 10,
      border: '2px solid #444',
      background: 'lightgoldenrodyellow',
      ...style,
    }}
  >
    <Text>{label ?? 'No Rows to Display'}</Text>
  </Container>
)

GridNoResultsOverlay.propTypes = {
  style: PropTypes.object,
  label: PropTypes.string,
}

GridNoResultsOverlay.defaultProps = {
  style: undefined,
  label: undefined,
}

export default GridNoResultsOverlay
